import { render, staticRenderFns } from "./AActivityAppointmentItem.vue?vue&type=template&id=5030e0e0&scoped=true"
import script from "./AActivityAppointmentItem.vue?vue&type=script&lang=js"
export * from "./AActivityAppointmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030e0e0",
  null
  
)

export default component.exports